// src/services/mapService.js

const BASE_URL = `${process.env.REACT_APP_BASE_URL}/api/v2/map`; 

export const getRoutesByCity = async (token, citId) => {
  try {
    const response = await fetch(`${BASE_URL}/get-routes-by-city-super-route/${citId}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    if (!response.ok) throw new Error('Error obteniendo rutas');
    return await response.json();
  } catch (error) {
    console.error("Error getRoutesByCity:", error);
    return [];
  }
};

export const getStopsByRoute = async (token, rouId) => {
  try {
    const response = await fetch(`${BASE_URL}/get-stops-by-route/${rouId}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    if (!response.ok) throw new Error(`Error obteniendo paradas para la ruta ${rouId}`);
    return await response.json();
  } catch (error) {
    console.error("Error getStopsByRoute:", error);
    return [];
  }
};